// Static content for the High Five Access landing site.

// Internal SPA route to the multi-step Apply page — replaces the
// legacy Google Form. Kept as a string so react-router-dom's <Link to>
// can consume it directly and every existing usage site keeps the same
// import path.
export const APPLY_URL = "/apply";

export const HFA_WHATSAPP = "7879960380";

export const FOUNDER = {
  name: "CA Rahul Bhojwani",
  title: "Founder, High Five Access",
  phone: "9977730486",
  photo:
    "https://customer-assets.emergentagent.com/job_pro-ecosystem/artifacts/7o740neh_WhatsApp%20Image%202026-06-24%20at%2003.53.08.jpeg",
};

export const INSTAGRAM = {
  handle: "@highfive.access",
  url: "https://instagram.com/highfive.access",
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Who It's For", href: "#who" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Circles", href: "#circles" },
  { label: "Membership", href: "#membership" },
  { label: "Contact", href: "#contact" },
];

export const MOBILE_NAV_LINKS = [
  { label: "What is High Five Access?", href: "#about" },
  { label: "Who Is It For?", href: "#who" },
  { label: "How Members Connect", href: "#how" },
  { label: "City Chapters", href: "#cities" },
  { label: "Professional Circles", href: "#circles" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Membership", href: "#membership" },
  { label: "Frequently Asked Questions", href: "#faq" },
  { label: "Founder", href: "#founder" },
  { label: "Contact", href: "#contact" },
];

export const CITIES = [
  "Mumbai",
  "Delhi NCR",
  "Bangalore",
  "Pune",
  "Hyderabad",
  "Raipur",
];

export const PROFESSIONAL_CIRCLES = [
  {
    title: "Finance, Legal & Compliance",
    icon: "Scale",
    fields: [
      "Accounting",
      "Taxation & GST",
      "Audit",
      "Banking & Investments",
      "Wealth Management",
      "Insurance",
      "Compliance",
      "Corporate & Company Law",
      "Litigation",
      "Contracts & Advisory",
      "Financial Markets",
      "Secretarial",
    ],
  },
  {
    title: "Marketing & Content",
    icon: "Megaphone",
    fields: [
      "Digital Marketing",
      "Social Media",
      "Content Creation",
      "Branding",
      "Graphic Design",
      "Copywriting",
      "SEO & Performance",
      "Influencer Marketing",
      "PR",
      "Podcasting",
      "Photography",
      "Videography",
    ],
  },
  {
    title: "Tech, Software & AI",
    icon: "Cpu",
    fields: [
      "Software Development",
      "Web & App Development",
      "SaaS & APIs",
      "Data Science & Analytics",
      "AI & Machine Learning",
      "UI/UX",
      "Automation",
      "Cloud",
      "Cybersecurity",
      "DevOps",
      "CRM & ERP",
    ],
  },
  {
    title: "Real Estate, Architecture & Interiors",
    icon: "Building2",
    fields: [
      "Real Estate",
      "Brokerage & Advisory",
      "Development",
      "Architecture",
      "Interior Design",
      "Construction",
      "Civil Engineering",
      "Project Management",
      "Infrastructure",
      "Property Services",
      "Home Services",
    ],
  },
  {
    title: "Education, Training & Coaching",
    icon: "GraduationCap",
    fields: [
      "Education & Teaching",
      "Coaching & Training",
      "Skill Development",
      "Career Coaching",
      "Corporate Training",
      "Business Consulting",
      "Mentoring",
      "Public Speaking",
      "EdTech",
      "Learning & Development",
    ],
  },
  {
    title: "Fitness & Wellness",
    icon: "Dumbbell",
    fields: [
      "Fitness & Gym Training",
      "Personal Training",
      "Yoga & Pilates",
      "Nutrition & Diet",
      "Lifestyle Coaching",
      "Preventive Health",
      "Mental Wellness",
      "Meditation",
    ],
  },
  {
    title: "Healthcare & Medical",
    icon: "Stethoscope",
    fields: [
      "Doctors & Specialists",
      "Dentists",
      "Clinics & Hospitals",
      "Diagnostics & Radiology",
      "Pharmacy & Pharmaceuticals",
      "Medical Devices",
      "Psychology",
      "Physiotherapy",
      "Healthcare Management",
      "Clinical Research",
      "Public Health",
    ],
  },
  {
    title: "Events and Experiences",
    icon: "PartyPopper",
    fields: [
      "Event Management",
      "Weddings",
      "Corporate Events",
      "Exhibitions",
      "Community Builders",
      "Venues",
      "Performing Artists",
      "Talent Management",
      "Sponsorships",
      "Logistics",
      "Decor & Catering",
    ],
  },
  {
    title: "Visual & Creative Arts",
    icon: "Palette",
    fields: [
      "Visual Artists",
      "Painters & Illustrators",
      "Sculptors",
      "Fine Arts",
      "Animation",
      "Fashion & Textile Design",
      "Styling",
      "Jewellery Design",
      "Makeup Artistry",
      "Set & Art Direction",
      "Calligraphy",
      "Tattoo Art",
    ],
  },
];

export const BENEFITS = [
  "Access to a curated professional community",
  "Access to Professional Circles relevant to your work profile",
  "Access to your City Chapter\u2019s cross-industry professional network",
  "Access to member-exclusive online networking meetups",
  "Eligibility to join member-exclusive offline networking meetups",
];

export const FAQS = [
  {
    q: "What makes High Five Access different?",
    a: "High Five Access takes a relationship-first approach rather than a transaction-first one. Connections across and within industries help build familiarity and trust, creating space to collaborate and discover the right opportunities over time.",
  },
  {
    q: "How do you maintain the quality of the community?",
    a: "Every application is thoughtfully reviewed before approval, and the community is actively moderated to maintain a relevant and respectful environment. Each group has a dedicated purpose, helping keep conversations focused, meaningful, and valuable for members.",
  },
  {
    q: "How are meetups organised within High Five Access?",
    a: "Dedicated City Captains host offline city meetups and online networking meetups that help members get to know each other, exchange ideas, collaborate, and discover new opportunities.",
  },
  {
    q: "What if my work doesn't fit into one of the Professional Circles?",
    a: "You can still be part of High Five Access through your City Chapter and connect with professionals across different fields. Professional Circles are an additional layer for deeper, field specific connections.",
  },
  {
    q: "How long is membership valid?",
    a: "Membership is valid for 12 months from the date of joining. If you wish to continue, you'll have the option to renew your membership before it expires.",
  },
  {
    q: "Is there any attendance requirement or time commitment?",
    a: "Not at all. There is no attendance structure. You can join virtual or in person meetups whenever it suits you, and you can stay engaged with the WhatsApp community at your own pace. The idea is to make High Five Access useful to your life, not the other way around.",
  },
];

export const VALUE_POINTS = [
  {
    title: "Discover opportunities",
    desc: "Surface collaborations, projects and potential clients through the right introductions.",
    icon: "Compass",
  },
  {
    title: "Find the right people",
    desc: "Freelancers, team members, partners or referrals. Sourced through trusted circles.",
    icon: "Users",
  },
  {
    title: "Get guidance and feedback",
    desc: "Ask for perspectives from people who have walked the path. Honest, useful, peer level.",
    icon: "MessageCircle",
  },
  {
    title: "Share your work",
    desc: "Put your ideas, expertise and craft in front of an audience that gets it.",
    icon: "Send",
  },
  {
    title: "Cross-field connections",
    desc: "A real estate professional meets legal, architecture, marketing. A doctor meets branding and content. Complementary fields lead to real outcomes.",
    icon: "Network",
  },
  {
    title: "Visibility, intentionally",
    desc: "Often the biggest unlock is simply being visible to the right people at the right time.",
    icon: "Eye",
  },
];
